import { getController } from '@/services/service'

const url = 'craftsman_task_persons'

export const craftsmanTaskPersonService = {
	...getController<Api.CraftsmanTaskPerson, Api.CraftsmanTaskPersonPostInput>(
		url
	),
}

export default craftsmanTaskPersonService
